//老师端接口
import {
  homePage
} from './homePage';
import {
  myProfile
} from './myProfile';
import {
  trainingMaterials
} from './trainingMaterials';
import {
  timetable
} from './timetable';
import {
  schedule
} from './schedule';
import {
  prebooked
} from './prebooked';
import {
  leave
} from './leave';
import {
  studyPlan
} from './studyPlan';

//公共接口
import {
  changePwd
} from './changePwd';
import {
  announcement
} from './announcement';
import {
  policy
} from './policy';

//老师代理端接口
import {
  payroll
} from './agent-api/payroll';
import {
  scheduledClasses
} from './agent-api/scheduledClasses';
import {
  feedback
} from './agent-api/feedback';
import {
  classStatisticPage
} from './agent-api/classStatisticPage';
import {
  statisticPage
} from './agent-api/StatisticPage';
import {
  resignationApplication
} from './agent-api/resignationApplication';

export default {
  ...homePage,
  ...myProfile,
  ...payroll,
  ...scheduledClasses,
  ...feedback,
  ...classStatisticPage,
  ...statisticPage,
  ...resignationApplication,
  ...changePwd,
  ...announcement,
  ...trainingMaterials,
  ...policy,
  ...timetable,
  ...schedule,
  ...prebooked,
  ...leave,
  ...studyPlan,
};



// WEBPACK FOOTER //
// ./src/api/index.js